  
<template> 
    <CadastroInline :processando="processando" titulo="Dados Cadastrais" v-if="formulario"  :key="index" :headerhidden="false" >   
        <div class="row g-6 g-xl-12">   
            <ListaCampoForm :campos="campos" :formulario="formulario" :disabled="!editando"  ></ListaCampoForm> 
        </div> 
        <br> 
        <hr> 
        <button type="button" class="btn btn-light me-10" @click="editar" v-if="!editando && hasPermissaoEditar">
            <span class="indicator-label">  <i class="fa fa-edit"></i>  Editar </span>
        </button>  
        <button type="button" class="btn btn-pmes-secondary me-10 float-right" v-if="!editando && hasPermissaoEditar" @click="atualizarRh"> 
            <span class="indicator-label">
            <i class="fa fs-2x fa-sync"></i> Atualizar Via RH
            </span> 
        </button>   
        <button type="button" class="btn btn-pmes-danger me-10" @click="cancelar" v-if="editando">
            <span class="indicator-label">  <i class="fa fa-window-close fs-2x"></i> Cancelar </span>
        </button>  
        <BotaoSalvar  @click="salvar" :processando="processando" v-if="editando && hasPermissaoEditar "></BotaoSalvar>   
    </CadastroInline>  
</template>

<script lang="ts">
    import CadastroInline from '@/components/aplicacao/CadastroInline.vue'; 
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue';  
    import {  Profile } from "./Profile"; 
    import   SiteUtils   from '@/assets/ts/aplicacao/site'; 
    import { Options, Vue  } from "vue-class-component";  
    import UsuarioService from   "@/service/v1/seguranca/UsuarioService"
    import {  Prop } from 'vue-property-decorator';   
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 

    @Options({
        name: "ProfileIndex",
        components: { CadastroInline, BotaoSalvar, ListaCampoForm },  
        emits: [ 'matricula-alterado'],
    }) 
    export default class ProfileIndex extends Vue {
        
        @authStore.Getter
		public perfis!: any  
        
        @Prop( ) readonly matricula!: any 

        public service = new UsuarioService() ; 
        public campos: Array<any> = [ ]; 
        public index = 1 ;  
        public editando = false;
        public processando = false;
        public isModelBuscado  = false ;  
        public isModelCriado  = true ; 
        public formulario: any  = {} ;
        public modelo: any  = {} ;
    
        created() {   
            this.campos =  Profile.campos();  
            this.buscarDados( );
        }
    
        public buscarDados(){   
            this.editando = false ;  
            this.isModelCriado = false;
            this.isModelBuscado = false; 
            this.service.getModel(this.matricula.usuarioId ) 
            .then(response => {  
                this.modelo =  JSON.parse(JSON.stringify( response ));   
                this.preparardados( ) ;  
            })
            .catch(error => {
                this.formulario = { }; 
                this.isModelCriado = false;
                this.isModelBuscado = true;
            });  
		}
 
        public cancelar(){  
            this.preparardados() ;  
            this.editando = false ; 
            this.index++;
        }
 
        public preparardados(   ){   
            this.editando = false ;  
            this.formulario = JSON.parse(JSON.stringify( this.modelo ));   
            this.index++;
            this.isModelCriado = true;
            this.isModelBuscado = true; 
		}
 
        get hasPermissao( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE , PerfilConfig.LeituraDE ] ,  this.perfis); 
        }
 
        get hasPermissaoEditar( ): boolean {
            return SiteUtils.hasPermissao( [ PerfilConfig.Admin ,  PerfilConfig.ChefeSTE ,  PerfilConfig.AuxSTE ] ,  this.perfis); 
        }

        public atualizar(){ 
            let dados = this.getdadosatualizar() ;   
            this.service.update( dados.id,  dados )
            .then(response => { 
                SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                this.buscarDados();
                this.sucesso();  
                this.processando = false ; 
                this.editando = false ;
                this.$emit("matricula-alterado", response);
            }) 
            .catch(error => {
                this.processando = false ;
                SiteUtils.toastErro('Error! ' ,  error.data.message  );
            });   
        } 
        
        
        public atualizarRh(){  
            this.service.updateRh(  this.formulario.id )
            .then(response => { 
                SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                this.buscarDados();
                this.sucesso();  
                this.processando = false ; 
                this.editando = false ;
                this.$emit("matricula-alterado", response);
            }) 
            .catch(error => {
                this.processando = false ;
                SiteUtils.toastErro('Error! ' ,  error.data.message  );
            });   
        } 
          

        public editar(){ 
            if( this.hasPermissaoEditar ){
                this.editando = true ;  
            }
            else {
                 this.editando = false ;
            } 
        }
 
        public sucesso(){  
            console.log('sucesso');
        }
 
        public getdadosatualizar(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }
 
        public salvar(){ 
            if( this.processando  ||  !this.hasPermissaoEditar ){
                return;
            }
            this.processando = true ;  
            setTimeout(() => {
                if( this.formulario.id ){
                    this.atualizar();  
                } 
            }, 20);  
        } 
 
    } 
</script>
 

<style scoped>
    .float-right{
        float: right;
    }
</style>
 